export default {
    name: 'AiCatalogApp'
};
